module.exports = __webpack_public_path__ + "img/xitong.25cf9126.png";